import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import "@govflanders/vl-ui-design-system-vanilla";

// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-core";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-util";

// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-autocomplete";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-data-table";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-popover";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-tabs";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-modal";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-accordion";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-select";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-multiselect";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-datepicker";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-slider";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-lightbox";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-upload";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-progress-bar";
// import "@govflanders/vl-ui-design-system-vanilla/vl-ui-form-validation";
import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

